<app-ui-main-menu>
  <mat-card>
    <mat-header>
      <mat-card-title>Central de Oportunidades</mat-card-title>
    </mat-header>
    <mat-divider></mat-divider>
    <br />
    <br />

    <mat-card-content>
      <div class="filter-container">
        <p>{{ this.userCredits }}</p>
        <div class="filter" *ngIf="selectedTab === 0">
          <span *ngIf="hasFilterOn" (click)="removeFilters()"> Limpar filtro </span>

          <mat-form-field appearance="outline" style="width: 100px">
            <mat-label>Estado</mat-label>
            <mat-select
              (selectionChange)="filterStateListener($event.value)"
              [formControl]="stateControl"
            >
              <mat-option *ngFor="let state of states" [value]="state">
                {{ state }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 200px">
            <mat-label>Cidade</mat-label>
            <input
              type="text"
              matInput
              placeholder="Procurar cidade..."
              [matAutocomplete]="auto"
              [(ngModel)]="selectedCity"
              (ngModelChange)="cityInputListener($event)"
              (blur)="validateCityInput()"
              [disabled]="!cities.length"
            />

            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
              (optionSelected)="filterCityListener($event.option.value)"
            >
              <mat-option *ngFor="let city of filteredCities$ | async" [value]="city">
                {{ city }}
              </mat-option>

              <mat-option *ngIf="!(filteredCities$ | async)?.length" disabled>
                Nenhuma cidade encontrada
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <button mat-button class="btn-primary" (click)="applyFilter()">Aplicar filtro</button>
        </div>
      </div>

      <mat-tab-group [(selectedIndex)]="selectedTab" [preserveContent]="false">
        <mat-tab label="Disponíveis">
          <ng-template matTabContent>
            <app-table
              [items]="allCases"
              [totalRows]="totalRows"
              [loading]="loading"
              (pageChange)="paginationChange($event)"
            >
              <app-card-cases
                *ngFor="let case of allCases"
                [data]="case"
                (acquireCase)="acquireCase($event)"
                [selectedTab]="1"
              ></app-card-cases>
            </app-table>
          </ng-template>
        </mat-tab>

        <mat-tab label="Meus Casos">
          <ng-template matTabContent>
            <app-my-cases></app-my-cases>
          </ng-template>
        </mat-tab>

        <mat-tab label="Histórico">
          <ng-template matTabContent>
            <app-history-cases></app-history-cases>
          </ng-template>
        </mat-tab>

        <!-- <mat-tab label="Minhas oportunidades">
          <ng-template matTabContent>
            <app-my-cases></app-my-cases>
          </ng-template>
        </mat-tab> -->
        <!-- <mat-tab label="Arquivados">
                <ng-template matTabContent>
                    <app-archived-cases></app-archived-cases>
                </ng-template>
                </mat-tab> -->
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
